import React from 'react';
import ColorPicker from '../../form/ColorPicker';
import ComponentField from '../../form/ComponentField';
import Figures from '../../form/Figures';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class ColorForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />    
                    </div>
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />    
                    </div>
                    <div className="col-md-4">
                        <ColorPicker
                            name="color_code"
                            value={this.props.values.color_code}
                            isClearable={true}
                            label="Szín"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("color_code")}
                        />  
                    </div>
                </div>
                <Figures
                    name="images"
                    label="Minta (kép)"
                    componentConfig={this.props.componentConfig}
                    data={this.props.values}
                />
            </form>
        );
    }
}

export default createForm(ColorForm);
